// extracted by css-extract-rspack-plugin
export default {"root":"_1tmxnmMy9VARcmLyZc6Icr","rootClickable":"_3ypv45-xXI7nMUfZWKDCZc","icon":"olHldq4N8e0CNKetvJW5t"};